// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"576f88df","804":"1d22a742","1382":"48c44b38","5516":"48c44b38"}[chunkId] + ".chunk.css";
};